import React from 'react';
import { Badge } from '@makemydeal/dr-ui-bricks-components';
import {
    SectionWrapper,
    ContentRow,
    SpecsGrid,
    SpecItem,
    Label,
    Value,
    PriceCard,
    PriceBlock,
    PriceCardLabel,
    StrikedPrice,
    DiscountLabel,
    DiscountValue,
    PriceDivider,
    FinalPriceLabel,
    FinalPrice,
    Header,
    Title,
    MetaRow
} from './SpecificationsSection.style';
import type { SpecificationsSectionProps } from '../../types/VehicleSectionProps';
import { vehicleSpecifications } from '../../constants';

export const SpecificationsSection: React.FC<SpecificationsSectionProps> = ({ vehicle }) => {
    return (
        <SectionWrapper data-testid="specifications-section">
            <Header>
                <Title level={5} weight="bold">
                    {vehicle.title}
                </Title>

                <MetaRow size="base">
                    {vehicle.vin && <span data-testid="spec-vin">{vehicle.vin}</span>}
                    {vehicle.stockNumber && <span data-testid="spec-sin">Stock# {vehicle.stockNumber}</span>}
                    {vehicle.isNotInStock && <Badge data-testid="spec-not-in-stock-badge">Not in Stock</Badge>}
                </MetaRow>
            </Header>

            <ContentRow>
                <SpecsGrid>
                    {vehicleSpecifications(vehicle).map((spec) => (
                        <SpecItem key={spec.label} data-testid={spec.testId}>
                            <Label size="small">{spec.label}</Label>
                            <Value size="small">{spec.value}</Value>
                        </SpecItem>
                    ))}
                </SpecsGrid>

                {vehicle.shouldShowPricing && (
                    <PriceCard data-testid="price-card">
                        {vehicle.showMsrp && (
                            <PriceBlock>
                                <PriceCardLabel size="small">{vehicle.msrpLabel}</PriceCardLabel>
                                <StrikedPrice size="large" weight="bold" isStrike={vehicle.showSavings}>
                                    ${vehicle.msrpValue!.toLocaleString()}
                                </StrikedPrice>
                            </PriceBlock>
                        )}
                        {vehicle.showSavings && (
                            <PriceBlock>
                                <DiscountLabel size="small" isSavings={vehicle.isSavings}>
                                    {vehicle.savingsLabel}
                                </DiscountLabel>
                                <DiscountValue size="large" weight="bold" isSavings={vehicle.isSavings}>
                                    {vehicle.savingsText}
                                </DiscountValue>
                            </PriceBlock>
                        )}
                        {vehicle.showSavings && <PriceDivider data-testid="price-divider" />}
                        {vehicle.showSellingPrice && (
                            <PriceBlock>
                                <FinalPriceLabel size="small" data-testid="selling-price-label">
                                    Final Price
                                </FinalPriceLabel>
                                <FinalPrice size="large" weight="bold" data-testid="selling-price-value">
                                    ${vehicle.sellingPriceValue!.toLocaleString()}
                                </FinalPrice>
                            </PriceBlock>
                        )}
                    </PriceCard>
                )}
            </ContentRow>
        </SectionWrapper>
    );
};
